"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    HotelLoadingSkeletonComponent: ()=>HotelLoadingSkeletonComponent
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const horizon_namespaceObject = require("@pcln/horizon");
require("react");
const HotelLoadingSkeletonComponent = ({ isMobile })=>{
    const count = isMobile ? 2 : 5;
    const skeletons = Array(count).fill(0).map((_, index)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
            className: "border-neutral-5 mb-6 h-[330px] w-[239px] flex-shrink-0 flex-row overflow-hidden rounded-xl border",
            children: [
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                    className: "h-[123px] w-[239px]",
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(horizon_namespaceObject.Skeleton, {
                        type: "image",
                        className: "h-full w-full rounded-t-xl",
                        animate: true
                    })
                }),
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                    className: "border-neutral-5 flex w-[239px] flex-col justify-between gap-2 p-4",
                    children: [
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                            className: "mb-4",
                            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(horizon_namespaceObject.Skeleton, {
                                type: "h4",
                                className: "w-full",
                                animate: true
                            })
                        }),
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                            className: "mb-4",
                            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(horizon_namespaceObject.Skeleton, {
                                type: "body3",
                                width: 151,
                                height: 12
                            })
                        }),
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(horizon_namespaceObject.Skeleton, {
                            type: "body3",
                            width: 88,
                            height: 12
                        }),
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(horizon_namespaceObject.Skeleton, {
                            type: "body3",
                            width: 236,
                            height: 12
                        }),
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                            className: "mt-4 flex items-center gap-1",
                            children: [
                                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(horizon_namespaceObject.Skeleton, {
                                    type: "btn_lg",
                                    width: 40,
                                    height: 24
                                }),
                                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(horizon_namespaceObject.Skeleton, {
                                    type: "body3",
                                    width: 83
                                }),
                                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(horizon_namespaceObject.Skeleton, {
                                    type: "body3",
                                    width: 63
                                })
                            ]
                        })
                    ]
                })
            ]
        }, `hotel-loading-skeleton-${index}`));
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
        className: "flex w-full flex-row gap-3 overflow-hidden px-4",
        children: skeletons
    });
};
exports.HotelLoadingSkeletonComponent = __webpack_exports__.HotelLoadingSkeletonComponent;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "HotelLoadingSkeletonComponent"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
